export default __webpack_public_path__ + "static/media/verypoor_inactive.663ed8e3.svg";